<script setup lang="ts">
import { ref } from 'vue'
import type { PreviewMessageProps } from '../types'
import CloseButton from '@/components/CloseButton.vue'
import { cn } from '@/lib/utils'

const props = defineProps<PreviewMessageProps>()

const isHovered = ref(false)
const touchStartPosition = ref({
  x: 0,
  y: 0,
})

function setTouchStartPosition(pos: { x: number, y: number }) {
  touchStartPosition.value = pos
}

function onMouseEnter() {
  isHovered.value = true
}

function onMouseLeave() {
  isHovered.value = false
}

function handleTouchStart(e: TouchEvent) {
  setTouchStartPosition({ x: e.touches[0].clientX, y: e.touches[0].clientY })
}

function handleTouchEnd(e: TouchEvent) {
  const x = e.changedTouches[0].clientX
  const y = e.changedTouches[0].clientY

  if (
    Math.abs(x - touchStartPosition.value.x) > 10
    || y - touchStartPosition.value.y > 10
  ) {
    props.onCloseClick()
  }

  setTouchStartPosition({ x: 0, y: 0 })
}

const defaultBackgroundColor = '#F7F8FF'
const defaultTextColor = '#303235'
</script>

<template>
  <div
    part="preview-message"
    :class="cn(placement === 'left' ? 'left-5' : 'right-5')"
    :style="`
    background-color: ${previewMessageTheme?.backgroundColor ?? defaultBackgroundColor};
    color: ${previewMessageTheme?.textColor ?? defaultTextColor};
    z-index:  42424242;
    bottom: calc(${buttonSize} + 32px);
    `"
    class="fixed max-w-[256px] rounded-md border border-border  flex items-center gap-4 shadow-md  cursor-pointer hover:shadow-lg p-4"
    @mouseenter="onMouseEnter"
    @mouseleave="onMouseLeave"
    @touchstart="handleTouchStart"
    @touchend="handleTouchEnd"
    @click="onClick"
  >
    <CloseButton v-model="isHovered" :on-click="onCloseClick" :preview-message-theme="previewMessageTheme" />
    <template v-if="avatarUrl">
      <img
        :src="avatarUrl"
        class="rounded-full w-8 h-8 object-cover"
        alt="Bot avatar"
        elementtiming="Bot avatar"
        fetchpriority="high"
      >
    </template>
    <p>{{ message }}</p>
  </div>
</template>
